import { THEME_CHANGE_EVENT } from './dither-colors'

/** sessionStorage key for a theme picked with the footer toggle. */
export const THEME_OVERRIDE_KEY = 'theme'

const SYSTEM_DARK = '(prefers-color-scheme: dark)'

/** The visitor's system setting, or light where it can't be read. */
export function systemTheme(): 'light' | 'dark' {
  return typeof window !== 'undefined' && window.matchMedia?.(SYSTEM_DARK).matches
    ? 'dark'
    : 'light'
}

/**
 * Inline script for the root layout. It runs before first paint and keeps
 * the theme on the visitor's system setting: a toggle pick overrides it for
 * the rest of the tab session only, and a change of the system setting
 * clears the pick and is followed live (THEME_CHANGE_EVENT tells the toggle
 * and the dither effects to re-paint). Older versions kept the pick in
 * localStorage forever; that key is dropped, so returning visitors match
 * their system again.
 */
export const THEME_BOOTSTRAP = `(function(){var h=document.documentElement,k=${JSON.stringify(THEME_OVERRIDE_KEY)},m;try{localStorage.removeItem(k)}catch(e){}try{m=matchMedia(${JSON.stringify(SYSTEM_DARK)})}catch(e){return}var p=null;try{p=sessionStorage.getItem(k)}catch(e){}if(p?p==='dark':m.matches)h.dataset.theme='dark';function follow(e){try{sessionStorage.removeItem(k)}catch(x){}var t=e.matches?'dark':'light';h.dataset.theme=t;window.dispatchEvent(new CustomEvent(${JSON.stringify(THEME_CHANGE_EVENT)},{detail:t}))}m.addEventListener?m.addEventListener('change',follow):m.addListener(follow)})()`

/**
 * The dark-theme twin of a baked SVG (scripts/generate-dark-art.ts writes
 * `<name>-dark.svg`). Render both with `theme-light-only` / `theme-dark-only`
 * and html[data-theme] shows the one for the current theme.
 */
export function darkTwin(src: string) {
  return src.replace(/\.svg$/, '-dark.svg')
}
